<template>
  <content-loader
    view-box="0 0 420 195"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
    height="195"
  >
    <!-- <rect x="-1" y="14" rx="0" ry="0" width="417" height="2" /> 
    <rect x="5" y="5" rx="0" ry="0" width="65" height="4" /> 
    <circle cx="74" cy="7" r="3" /> 
    <rect x="353" y="3" rx="0" ry="0" width="43" height="8" /> 
    <rect x="110" y="27" rx="0" ry="0" width="2" height="154" /> 
    <rect x="5" y="34" rx="0" ry="0" width="78" height="3" /> 
    <rect x="130" y="66" rx="0" ry="0" width="246" height="3" /> 
    <rect x="5" y="45" rx="0" ry="0" width="78" height="3" /> 
    <rect x="5" y="56" rx="0" ry="0" width="78" height="3" /> 
    <rect x="5" y="68" rx="0" ry="0" width="78" height="3" /> 
    <rect x="130" y="77" rx="0" ry="0" width="246" height="3" /> 
    <rect x="130" y="89" rx="0" ry="0" width="246" height="3" /> 
    <rect x="130" y="101" rx="0" ry="0" width="246" height="3" /> 
    <rect x="130" y="113" rx="0" ry="0" width="246" height="3" /> 
    <rect x="130" y="124" rx="0" ry="0" width="246" height="3" /> 
    <rect x="131" y="136" rx="0" ry="0" width="246" height="3" /> 
    <rect x="130" y="148" rx="0" ry="0" width="246" height="3" /> 
    <rect x="223" y="40" rx="0" ry="0" width="65" height="5" /> 
    <rect x="112" y="27" rx="0" ry="0" width="282" height="2" /> 
    <rect x="392" y="27" rx="0" ry="0" width="2" height="154" /> 
    <rect x="110" y="181" rx="0" ry="0" width="283" height="2" /> 
    <rect x="130" y="55" rx="0" ry="0" width="246" height="3" /> 
    <rect x="130" y="161" rx="0" ry="0" width="246" height="3" /> -->

    <rect x="-1" y="17" rx="1" ry="1" width="417" height="1" /> 
    <rect x="5" y="8" rx="0" ry="0" width="57" height="3" /> 
    <circle cx="66" cy="9" r="3" /> 
    <rect x="353" y="5" rx="0" ry="0" width="43" height="8" /> 
    <rect x="82" y="43" rx="0" ry="0" width="1" height="158" /> 
    <rect x="317" y="43" rx="0" ry="0" width="1" height="157" /> 
    <rect x="83" y="200" rx="0" ry="0" width="235" height="1" /> 
    <rect x="82" y="35" rx="0" ry="0" width="103" height="4" /> 
    <rect x="82" y="43" rx="0" ry="0" width="235" height="1" /> 
    <rect x="159" y="55" rx="0" ry="0" width="78" height="4" /> 
    <rect x="94" y="70" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="76" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="82" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="88" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="94" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="100" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="106" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="112" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="118" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="124" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="130" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="136" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="142" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="148" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="154" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="160" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="166" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="172" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="178" rx="0" ry="0" width="209" height="2" /> 
    <rect x="94" y="184" rx="0" ry="0" width="209" height="2" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "DocumentLoader",
    components: { ContentLoader }
};
</script>